const weblog = window.weblog;
const Yoda = window.Yoda;

export function getParams() {
  const searchParams = new URL(location.href).searchParams;
  const query: any = {};
  [...searchParams].forEach(([key, value]) => {
    query[key] = value;
  });
  return query;
}

export function openPage(url: string, yoda: any, openOnNewPage: boolean = true): void {
  if (!url) return;
  if (openOnNewPage == false || /^kwai:\/\/.+/.test(url)) {
    location.href = url;
    return;
  }
  if (url[0] === '.') {
    url = resolvePathname(url, location.pathname);
  }
  if (url[0] === '/') {
    url = location.protocol + '//' + location.host + url;
  }
  if (yoda && yoda.kwai && yoda.kwai.loadUrlOnNewPage && url.indexOf('http') === 0) {
    yoda.kwai.loadUrlOnNewPage({ url, type: 'back' });
  } else {
    location.href = url;
  }
}

export function back(yoda: any) {
  console.log('back');
  let kwai = yoda?.kwai || yoda?.Kwai || {};
  if (kwai.popBack) {
    kwai.popBack();
  } else if (kwai.exitWebView) {
    kwai.exitWebView();
  } else {
    history?.back();
  }
}

export function share(env, logger, shareParams, cb) {
  // env?.yoda?.ui?.showLoading('分享中...');
  if (typeof env?.yoda?.kwai.share === 'function') {
    if (shareParams?.subBiz) {
      // 自定义分享配置
      env.yoda.Kwai.share(
        {
          param: {
            shareContent: 'ACTIVITY',
            showSharePanel: true,
            shareObjectId: docCookie.getItem('ud'),
            ...shareParams,
          },
        },
        function (res) {
          typeof cb === 'function' && cb(res);
          // env?.yoda?.ui?.hideLoading();
        },
      );
    } else {
      // 页面默认分享配置
      env.kwai.share(
        {
          ...shareParams,
        },
        function (res) {
          typeof cb === 'function' && cb(res);
          // env?.yoda?.ui?.hideLoading();
        },
      );
    }
  } else {
    logger?.error('无法调起分享');
    // env?.yoda?.ui?.hideLoading();
  }
}

export function login(forceLogin?): Promise<{}> {
  return new Promise<{}>((resolve, reject) => {
    const ud = docCookie.getItem('ud');
    const userId = docCookie.getItem('userId');
    const ifLogin = (ud && +ud !== 0) || (userId && +userId !== 0);
    if (!ifLogin) {
      if (forceLogin === undefined || forceLogin) {
        if (Yoda && Yoda.Kwai) {
          Yoda.Kwai.login({}, (res) => {
            if (res.result === 1) {
              location.reload(); //登录成功页面刷新
            }
          });
        } else {
          reject(`Yoda&&Yoda.Kwai 未定义,请在端内调试.`);
        }
      } else {
        reject(`User not login.`);
      }
    } else {
      resolve({ id: ud || userId });
    }
  });
}

export async function yodaShare(yoda, shareConfig, openShare, shareParams, cb, paramsForLog) {
  // 未开启分享或分享的subBiz不存在
  if (!openShare || !shareConfig.subBiz) return;

  try {
    await yoda.ready();
    const logParams = Object.assign(
      {
        share_source: 'FANGZHOU_H5',
        share_scene: '',
      },
      paramsForLog,
    );

    let configParam = {
      subBiz: shareConfig.subBiz,
      showSharePanel: true,
      shareObjectId: `FANGZHOU_${shareConfig.activityToken}`,
      logParams: JSON.stringify(logParams),
    };

    if (typeof shareParams === 'object') {
      configParam = Object.assign(configParam, shareParams);
    }

    //      //116返场特殊需求
    // if(configParam.subBiz === "FANGZHOU_DFODMRLDALU") {
    //     configParam.subBiz = "SHOP_FANCHANG";
    // }

    const res = await yoda.Kwai?.share({ param: configParam });

    typeof cb === 'function' && cb(res);
    if (res.result !== 1) {
      weblog.sendImmediately('CUSTOM', {
        key: 'FANGZHOU_SHARE_SUCCESS',
        value: {
          subBiz: shareConfig.subBiz,
        },
      });
    } else {
      weblog.sendImmediately('CUSTOM', {
        key: 'FANGZHOU_SHARE_ERROR',
        value: {
          subBiz: shareConfig.subBiz,
          errorMsg: '接口失败',
        },
      });
    }
    return res;
  } catch (e) {
    console.log(`分享失败：${JSON.stringify(e)}`, shareConfig.subBiz);
    weblog.sendImmediately('CUSTOM', {
      key: 'FANGZHOU_SHARE_ERROR',
      value: {
        subBiz: shareConfig.subBiz,
        errorMsg: '分享调用失败',
      },
    });
  }
}

function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

function spliceOne(list, index) {
  for (let i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

function resolvePathname(to, from) {
  if (from === undefined) from = '';

  const toParts = (to && to.split('/')) || [];
  let fromParts = (from && from.split('/')) || [];

  const isToAbs = to && isAbsolute(to);
  const isFromAbs = from && isAbsolute(from);
  const mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  let hasTrailingSlash;
  if (fromParts.length) {
    const last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  let up = 0;
  for (let i = fromParts.length; i >= 0; i--) {
    const part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  let result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

const docCookie = {
  getItem: function (sKey) {
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            '(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$',
          ),
          '$1',
        ),
      ) || null
    );
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
      }
    }
    document.cookie =
      encodeURIComponent(sKey) +
      '=' +
      encodeURIComponent(sValue) +
      sExpires +
      (sDomain ? '; domain=' + sDomain : '') +
      (sPath ? '; path=' + sPath : '') +
      (bSecure ? '; secure' : '');
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) {
      return false;
    }
    document.cookie =
      encodeURIComponent(sKey) +
      '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
      (sDomain ? '; domain=' + sDomain : '') +
      (sPath ? '; path=' + sPath : '');
    return true;
  },
  hasItem: function (sKey) {
    return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=').test(
      document.cookie,
    );
  },
};
